<template>
  <div>
    <div class="pa-4 pa-md-2">
      <Breadcrumbs
        :headline="major.title"
        :link="[
          { text: 'Chuyên ngành', href: '/majors' },
          { text: major.title, href: $route.path }
        ]"
      />
    </div>

    <div
      class="major-information mb-5 pa-2 mx-md-2"
      :style="{
        'background-image': `url(${majorDefaultImage})`
      }"
    >
      <v-row no-gutters>
        <v-col :xs="12" :md="6" :lg="4">
          <div class="major-information__content">
            <v-btn
              v-if="canEditMajor"
              class="major-information__edit-button"
              icon
              small
              dark
              @click="dialog = true"
            >
              <v-icon small>edit</v-icon>
            </v-btn>

            <div class="mb-2">Chuyên ngành:</div>
            <div class="display-1 mb-3">{{ major.title }}</div>
            <table class="major-information__table">
              <tr>
                <td>
                  <div class="major-information__label">Mã chuyên ngành</div>
                </td>
                <td class="major-information__value">{{ major.code }}</td>
              </tr>
              <tr>
                <td class="major-information__label">Mô tả</td>
                <td class="major-information__value">
                  {{ major.description }}
                </td>
              </tr>
            </table>
          </div>
        </v-col>
      </v-row>
    </div>
    <v-dialog :fullscreen="$vuetify.breakpoint.mobile" v-model="dialog" width="600">
      <v-card>
        <v-toolbar color="#FFB300" dense class="elevation-0" dark>
          <v-toolbar-title>Chỉnh sửa thông tin chuyên ngành</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-5">
          <major-form ref="majorForm" :major="major" class="flex-grow-1 ma-2"></major-form>
          <major-media-form
            ref="majorMediaForm"
            :major="major"
            class="flex-grow-1 ma-2"
          ></major-media-form>
        </v-card-text>
        <v-card-actions class="pa-5 pt-0">
          <v-spacer></v-spacer>
          <v-btn class="px-3" color="primary" @click="save">
            <span>Lưu</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card class="pa-2 mx-md-2">
      <div class="headline mb-5" style="color: #ffb300">Danh sách môn học</div>
      <major-courses :major="major"></major-courses>
    </v-card>
  </div>
</template>

<script>
import MajorMediaForm from '@/modules/major/MajorMediaForm'
import MajorForm from '@/components/basic/form/MajorForm.vue'
import MajorCourses from '@/modules/major/MajorCourses.vue'
import { mapActions, mapGetters } from 'vuex'
import MajorDefaultImage from '@/assets/major-image-default.png'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
export default {
  components: {
    MajorCourses,
    MajorForm,
    MajorMediaForm,
    Breadcrumbs
  },
  data() {
    return {
      dialog: false,
      majorDefaultImage: MajorDefaultImage
    }
  },
  async created() {
    await this.fetchMajor(this.$route.params.id)
  },

  computed: {
    ...mapGetters('majorDetail', ['major']),
    ...mapGetters('auth', ['role']),
    majorData() {
      return this.major
    },
    canEditMajor() {
      return ['education_manager', 'super_admin'].includes(this.role.type)
    }
  },
  methods: {
    ...mapActions('majorDetail', ['updateMajor', 'fetchMajor']),
    cancel() {
      this.$refs.majorForm.reset()
    },
    save() {
      const metadata = this.$refs.majorMediaForm.getData()
      console.log(metadata)
      this.updateMajor({
        id: this.major.id,
        ...this.$refs.majorForm.getData(),
        metadata: metadata
      })
    }
  }
}
</script>
<style scoped>
.border {
  border: solid 1px lightgray !important;
  border-radius: 4px;
}

.major-information {
  height: 292px;
  background-size: cover;
  padding: 20px;
}

.major-information__content {
  position: relative;
  padding: 20px;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 4px;
}

.major-information__label {
  margin-right: 20px;
  min-width: 128px;
}

.major-information__edit-button {
  position: absolute;
  top: 10px;
  right: 10px;
}
</style>
